import React from "react";
import styled from "styled-components";
import Logo from "./Logo";

const Header = styled.div`
  background-color: #fff;
  box-shadow: 0 2px 8px 0 rgba(190, 190, 190, 0.5);
  color: #bababc;
  height: 70px;
  line-height: 70px;
  position: fixed;
  top: 0;
  width: 100%;
`;

const Wrapper = styled.div`
  margin: 0 auto;
  max-width: 1280px;
  padding: 0 20px;
  position: relative;
`;

const LogoWrapper = styled.a`
  color: #555d63;
  display: inline-block;
  padding: 10px 0;
`;

const Links = styled.div`
  display: block;
  margin-left: 20px;
  position: absolute;
  right: 30px;
  top: 0;

  a {
    color: #555d63;
    text-decoration: none;
  }
`;

const Navigation = () => (
  <Header>
    <Wrapper>
      <LogoWrapper>
        <Logo href="/#/" className="logo" />
      </LogoWrapper>
      <Links>
        <a href="https://github.com/loadsmart/icons/releases">Release notes</a>
      </Links>
    </Wrapper>
  </Header>
);

export default Navigation;
